import styled from 'styled-components/macro'
import Carousel from 'react-elastic-carousel'

export const SliderContainer = styled.div`
  padding: 5em 5em;
  position: relative;

  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    padding: 3em 0;
  }

  .slick-slide {
    max-width: calc(100% / 3);
    @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
      max-width: 100%;
    }
  }

  .slick-dots,
  .slick-slider {
    position: initial;
  }

  .slick-next,
  .slick-prev {
    width: 80px;
    height: 80px;
    z-index: 100;

    &::before {
      font-size: 30px;
      color: rgba(73, 75, 87, 0.5);
    }
  }

  .slick-next {
    right: -16px;
    clip-path: inset(0 23% 0 0);
  }

  .slick-prev {
    left: -15px;
    clip-path: inset(0 0 0 23%);
  }
`

export const Dots = styled.ul`
  position: absolute;
  width: 100%;

  li,
  li button,
  li button::before {
    width: 40px;
    height: 40px;
    font-size: 1em;
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    zoom: 60%;
  }
`
//@ts-ignore
export const UpperDots = styled(Dots)`
  top: 2em;
`
export const LowerDots = styled(Dots)`
  bottom: 0;
`
export const StyledCarousel = styled(Carousel)`
  /* square buttons */
  .rec.rec-arrow {
    /* position: absolute; */
    border-radius: 50%;
    z-index: 1;
    opacity: 50%;
    background-color: ${props => props.theme.colors.primary};
  }
  /* round buttons on hover */
  .rec.rec-arrow:hover {
    background-color: ${props => props.theme.colors.primary};
    border-radius: 50%;
  }
  /* hide disabled buttons */
  .rec.rec-arrow:disabled {
    visibility: hidden;
  }
  /* disable default outline on focused items */
  /* add custom outline on focused items */
  .rec-carousel-item:focus {
    outline: none;
    box-shadow: inset 0 0 1px 1px lightgrey;
  }
`
